<mat-card>
  <form [formGroup]="noteForm" (ngSubmit)="submitNote()">
    <mat-card-header>
      <mat-card-title>{{ note.id ? 'Edit Note' : 'New Note' }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-button-toggle-group formControlName="type">
        <mat-button-toggle value="thing" matTooltip="Interesting Things">
          <div class="type-toggle" aria-label="Interesting Things button">
            <img src="/assets/img/fuzzy.png" class="topic" />
          </div>
        </mat-button-toggle>
        <mat-button-toggle value="question" matTooltip="Questions">
          <div class="type-toggle" aria-label="Questions button">
            <img src="/assets/img/ruby.png" class="topic" />
          </div>
        </mat-button-toggle>
        <mat-button-toggle value="word" matTooltip="New Words">
          <div class="type-toggle" aria-label="New Words button">
            <img src="/assets/img/vocabacorn.png" class="topic" />
          </div>
        </mat-button-toggle>
      </mat-button-toggle-group>
      <div class="textarea-wrapper">
        <textarea matInput formControlName="message"></textarea>
      </div>
    </mat-card-content>
    <mat-card-actions>
      <button
        type="submit"
        class="sub-btn left-btn"
        color="primary"
        aria-label="send note button"
        [ngClass]="{ disabled: !sendButtonEnable }"
        [disabled]="!sendButtonEnable"
      >
        <img src="/assets/img/send.png" />
      </button>
      <button
        type="button"
        class="sub-btn"
        color="primary"
        aria-label="close note editor"
        (click)="close()"
      >
        <mat-icon color="primary">close</mat-icon>
      </button>
    </mat-card-actions>
  </form>
</mat-card>
